<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="500px" scrollable id="freetext-modal">
        <v-progress-linear v-if="processingFreeText" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <form>
                    <ValidationProvider
                            v-slot="{ errors }"
                            name="フリー欄"
                            vid="freeText"
                            ref="v-freeText"
                    >
                      <v-textarea
                              ref="freeText"
                              class="px-3"
                              v-model="freeText"
                              name="freeText"
                              label="フリー欄"
                              clearable
                              data-vv-as="フリー欄"
                              :error-messages="mergedErrorMessages(errors[0])"
                              :hide-details="true"
                      />
                      <ul :class="$style['error-messages']">
                        <li
                                v-for="(error,key) in mergedErrorMessages(errors[0])"
                                :key="key"
                        >{{error}}</li>
                      </ul>
                    </ValidationProvider>
                  </form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
          <template #footer>
            <CButton
                    :class="$style['reset-dialog-btn']"
                    color="primary"
                    @click="dialog = false"
            >閉じる</CButton>
            <v-btn :class="$style['reset-dialog-btn']" color="primary" @click.native="submit">更新</v-btn>
          </template>
    </CModal>
  </v-layout>
</template>

<script>
  import utility from "@/utility";
export default {
  props: {
    resourceName: {
      type: String
    }
  },
  data() {
    return {
      isChanged: false,
      resetFlg: false,
      id: null
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (show) {
        if(!this.isChanged) {
          this.$store.dispatch(`${this.resourceName}/entity/showFreeText`, {
            pk: this.pk
          });
        }
        this.id = this.pk;
      } else {

        if(this.isChanged) {
          utility
            .$confirm("入力内容を破棄してよろしいですか？", "確認", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "success",
              center: true
            })
            .then(() => {

              const freeTextProvidor = vm.$refs["v-freeText"];
              freeTextProvidor.reset();

              this.isChanged = false;

              this.resetFreeText();
            })
            .catch(() => {
              this.$store.commit(this.resourceName + "/entity/openFreeText", {pk: this.id});
            });
        }
        else{
          const freeTextProvidor = vm.$refs["v-freeText"];
          freeTextProvidor.reset();
          this.resetFreeText();
        }
      }
    },
    processingFreeText(value) {
      if (value) {
        // ローディングマスクを差し込む
        this.$nextTick(() => {
          const overlayHtml = '<div id="freetext-modal-overlay" class="v-overlay v-overlay--absolute v-overlay--active theme--dark" style="z-index: 5;"><div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div><div class="v-overlay__content"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--indeterminate" style="height: 64px; width: 64px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="21.333333333333332 21.333333333333332 42.666666666666664 42.666666666666664" style="transform: rotate(0deg);"><circle fill="transparent" cx="42.666666666666664" cy="42.666666666666664" r="20" stroke-width="2.6666666666666665" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg><div class="v-progress-circular__info"></div></div></div></div>';
          const modal = document.getElementById('freetext-modal');
          if (modal) {
            const contents = modal.getElementsByClassName('modal-content');
            if (contents.length) {
              contents[0].insertAdjacentHTML('beforebegin', overlayHtml);
            }
          }
        });
      } else {
        const overlay = document.getElementById('freetext-modal-overlay');
        if (overlay) {
          overlay.remove();
        }
      }
    }
  },
  computed: {
    pk() {
      return this.$store.getters[this.resourceName + "/entity/freeTextPk"];
    },
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/entity/freeTextOpen"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/entity/freeTextClose");
      }
    },
    freeText: {
      get() {
        return this.$store.getters[`${this.resourceName}/entity/freeText`] || "";
      },
      set(value) {
        if(this.freeText !== "" && !this.resetFlg){
          this.isChanged = true;
        }
        this.resetFlg = false;
        this.$store.commit(this.resourceName + "/entity/freeText", {
          value: value
        });
      }
    },
    processingFreeText() {
      return this.$store.getters[`${this.resourceName}/entity/processingFreeText`] || null;
    },
    dialogTitle() {
      return "フリー欄編集";
    },
    errorMessages() {
      return this.$store.getters[this.resourceName + `/list/errorMessages`] || {};
    },
    mergedErrorMessages() {
      return vvErr => {
        const messages = [];
        const errorMessages = (this.errorMessages || {}) || [];
        if (vvErr) {
          messages.push(vvErr);
        }
        if (errorMessages.length) {
          errorMessages.forEach(v => messages.push(v));
        }
        return messages;
      };
    },
    mergedConfirmErrorMessages() {
      return vvErr => {
        const messages = [];
        if (vvErr) {
          messages.push(vvErr);
        }
        return messages;
      };
    }
  },
  methods: {
    async submit() {
      const freeTextProvidor = this.$refs["v-freeText"];
      const freeTextResult = await freeTextProvidor.validate();

      if (freeTextResult.valid) {
        this.isChanged = false;

        this.$store
          .dispatch(this.resourceName + "/entity/updateFreeText", {
            pk: this.pk,
            value: this.freeText
          })
          .then(() => {
            this.$message({
              message: "更新が完了しました。",
              type: "success"
            });
          });
      }
    },
    resetFreeText() {
      // 直前に表示していた値が一瞬表示されるのを防ぐためリセットする
      // このリセット契機で破棄確認を出したくないためフラグを立てておく
      this.resetFlg = true;
      this.freeText = '';
    }
  },
  mounted() {
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 0px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.error-messages {
  margin: 0;
  margin-top: 8px !important;
  padding-left: 46px !important;
  & > li {
    list-style-type: none;
    min-height: 23px;
    line-height: 12px;
    font-size: 12px;
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
